import { LinearProgress } from '@mui/material';
import React, { Suspense } from 'react';
import { Toaster } from 'sonner';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { CalenderTodayWrapper } from '../CalenderTodayWrapper';
import SkillsWrapper from '../SkillsWrapper';
import { AuthCheck } from './AuthCheck';
const NotLoginRouter = React.lazy(() => import('../../routers/notLoginRouter'));
const AuthRouter = React.lazy(() => import('../../routers/authRouter'));
const NotificationWrapper = React.lazy(() => import('../NotificationWrapper'));


const queryClient = new QueryClient()
const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<LinearProgress />}>
        <AuthCheck fallback={<NotLoginRouter />}>
          <SkillsWrapper>
            <CalenderTodayWrapper>
              <NotificationWrapper>
                <AuthRouter />
              </NotificationWrapper>
            </CalenderTodayWrapper>
          </SkillsWrapper>
        </AuthCheck>
      </Suspense>
      <Toaster position='top-center' />
    </QueryClientProvider>
  );
};
export default App;
